'use strict';

var $ = require('jquery');
var progress = require('../../utils/progress');
var util = require('../../utils/util');

function updateApplePayButton(showFormErrors) {
    var isSalutationValid = validateSalutation();
    var isTermsValid = validateTermsAndConditions();

    if (isSalutationValid && isTermsValid) {
        $('.applepay-button').removeClass('invalid-form');
        $('.summary-salutation').removeClass('error-form').addClass('warning-form');
        $('.error-accept-terms').hide();
    } else {
        $('.applepay-button').addClass('invalid-form');
    }

    if (showFormErrors && !isSalutationValid) {
        $('.summary-salutation').removeClass('warning-form').addClass('error-form');
        util.scrollBrowser($('#main').offset().top, true);
    } else if (isSalutationValid) {
        $('.summary-salutation').removeClass('error-form').addClass('warning-form');
    }

    if (showFormErrors && !isTermsValid) {
        $('.error-accept-terms').show();
        util.scrollBrowser($('#main').offset().top, true);
    } else if (isTermsValid) {
        $('.error-accept-terms').hide();
    }

    return;
}

function validateSalutation() {
    var salutationValue = $('.summary-salutation').find('option:selected').val();

    if (salutationValue) {
        $.ajax({
            type: 'POST',
            url: util.appendParamToURL(Urls.applePaySalutation, 'salutation', salutationValue)
        });

        return true;
    }

    return false;
}

function newsletterSubscription() {
    var $newsletter = $('.newsletter-subscription');
    var newsletterValue = $newsletter.find('input[type="checkbox"]:checked').length ? 'true' : 'false';

    $.ajax({
        type: 'POST',
        url: util.appendParamToURL(Urls.applePayNewsletters, 'newsletter', newsletterValue)
    });

    return;
}

function validateTermsAndConditions() {
    var $terms = $('.terms-and-conditions');
    var termsValue = $terms.find('input[type="checkbox"]:checked').length;

    if (termsValue) {
        return true;
    }

    return false;
}

function validateCheckoutTerms() {
    var $terms = $('.terms-small');
    var termsValue = $terms.find('input[type="checkbox"]:checked').length;

    if (termsValue) {
        $('.error-acceptterms').css('display', 'none');
        $('.applepay-button').removeClass('invalid-form');
        return true;
    } else {
        $('.applepay-button').addClass('invalid-form');
    }

    return false;
}

function validateApplePaySummary() {
    var $salutation = $('.summary-salutation');
    var $terms = $('.terms-and-conditions');
    var $newsletter = $('.newsletter-subscription');

    $salutation.on('change', 'input[type="select"]', function () {
        updateApplePayButton();
    });

    $terms.on('change', 'input[type="checkbox"]', function () {
        updateApplePayButton();
    });

    $newsletter.on('change', 'input[type="checkbox"]', function () {
        newsletterSubscription();
    });

    $('.applepay-summary-page .applepay-button.invalid-form').on('click', function () {
        progress.show('#primary');

        updateApplePayButton(true);
        setTimeout(function () {
            progress.hide('#primary');
        }, 500);
    });
}

function validateCheckoutApplePay() {
    $('.order-summary-page .terms-small').on('change', 'input[type="checkbox"]', validateCheckoutTerms);

    $('.order-summary-page .applepay-button.invalid-form').on('click', function () {
        let isCheckoutTermsValid = validateCheckoutTerms();
        if (!isCheckoutTermsValid) {
            $('.applepay-button').addClass('invalid-form');
            $('.error-acceptterms').css('display', 'block');
            util.scrollBrowser($('#main').offset().top, true);
        }
        progress.show('#primary');
        setTimeout(function () {
            progress.hide('#primary');
        }, 500);
    });
}

function isApplePaySession() {
    return window.ApplePaySession && window.ApplePaySession.canMakePayments;
}

var applepay = {
    isApplePaySession: isApplePaySession,
    init: function () {
        if ($('.applepay-summary-page').length) {
            validateApplePaySummary();
        }

        if ($('.order-summary-page .applepay-wrapper').length) {
            validateCheckoutApplePay();
        }

        if (isApplePaySession()) {
            $('.apple-pay-option').show();
        } else {
            $('.apple-pay-option').hide();

            // Remove the <isapplepay> tag, which is not a valid HTML element, if ApplePay is not available
            $('#apple-pay-pdp-button').remove();
        }
    }
};

module.exports = applepay;
